import { useEffect } from 'react';

interface Props {
    isActive?: boolean;
    color: string;
}

// The iOS status bar in safari inherits the background color of the body: https://css-tricks.com/the-notch-and-css/

export const useIPhoneSafariStatusBarColor = ({
    isActive = true,
    color
}: Props) => {
    // TODO: create DeviceService in react
    const isIPhone = navigator.userAgent.match(/iPhone/i);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (isIPhone && isActive) {
            const meta = document.createElement('meta');
            meta.setAttribute('name', 'theme-color');
            meta.setAttribute('content', color);
            document.head.appendChild(meta);

            return () => {
                document.head.removeChild(meta);
            };
        }
    }, [isIPhone, isActive, color]);
};
